let UTILS = require("../libs/utils.js");
var v7702;
var v7703;
module.exports = {
  id: "boss",
  name: "Boss Hunt",
  alias: "boss",
  winCondition: function (game) {
    var vLN01195 = 0;
    for (var vLN01196 = 0; vLN01196 < game.players.list.length; ++vLN01196) {
      if (game.players.list[vLN01196].active && game.players.list[vLN01196].team == 2) {
        vLN01195++;
      }
    }
    if (vLN01195 > 0) {
      return 2;
    } else {
      return 1;
    }
  },
  condition: [function (game) {
    var vLN01197 = 0;
    for (var vLN01198 = 0; vLN01198 < game.players.list.length; ++vLN01198) {
      if (game.players.list[vLN01198].active && game.players.list[vLN01198].team == 2) {
        vLN01197++;
      }
    }
    return vLN01197 > 0;
  }],
  waitTimers: [{
    time: 15000,
    msg: "picking boss in ",
    trigger: function (p9121) {
      p9121.pickBoss();
    }
  }],
  teams: true,
  teamOptions: ["Heros", "Boss"],
  noReward: true,
  minPlayers: 2
};